import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";
import get from "lodash/get";

import { setActiveFolder, setActiveRecord } from "../../store/modules/library/actions";
import { ROOT_FOLDER } from "../../store/modules/library/constants";
import { getActiveFolder, getActiveRecord, getIsRootExist } from "../../store/modules/library/selectors";

export enum ActiveType {
  record = "record",
  folder = "folder",
}

const getActive = {
  [ActiveType.record]: getActiveRecord,
  [ActiveType.folder]: getActiveFolder,
};

const setActive = {
  [ActiveType.record]: setActiveRecord,
  [ActiveType.folder]: setActiveFolder,
};

const matchProps = {
  [ActiveType.record]: {
    path: "/record/:id",
    exact: true,
  },
  [ActiveType.folder]: {
    path: ["/", "/folder/:id"],
    exact: true,
  },
};

const defaultId = {
  [ActiveType.record]: undefined,
  [ActiveType.folder]: ROOT_FOLDER,
};

type TParams = {
  id: string;
};

export const useSetActive = (type: ActiveType) => {
  const activeId = useSelector(getActive[type]);
  const isRootExist = useSelector(getIsRootExist);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isRootExist) {
      const match = matchPath<TParams>(pathname, matchProps[type]);
      if (match) {
        const id = get(match, ["params", "id"], defaultId[type]);

        if (id !== activeId) {
          dispatch(setActive[type](id));
        }
      }
    }
  }, [type, activeId, isRootExist, pathname, dispatch]);
};
